import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFethSize } from '../../services/SystemSettings/SystemSettingsService';
import { setFetchSize } from '../../redux/search.slice';
import CloudExecutionManagement from './CloudExecutionManagement';
import {GetErpTypeFromConfig} from "../../App";
let tabref: TabComponent = new TabComponent({});
const CloudExecution = () => {
  const reduxEventId = useSelector((state: any) => state.search.event_id);
  const ERP_TYPE = GetErpTypeFromConfig();
  const dispatch = useDispatch();
  let page_range_from_settings: number;

  useEffect(() => {
    if (reduxEventId !== 0) {
      tabref.select(0);
    }
  }, [reduxEventId]);
  const getFetchSize = async () => {
    const model = await getFethSize();
    if (model.data.length === 0) {
      dispatch(setFetchSize(300));
    } else {
      model.data.map((item: any) => {
        if (item.isChecked === true) {
          page_range_from_settings = item.fetch_size;
        }
      });
      dispatch(setFetchSize(page_range_from_settings));
    }
  };

  useEffect(() => {
    getFetchSize();
    var now = new Date();
    var utc = now.getTimezoneOffset() / 60;
    if (ERP_TYPE !== 'MEX') {
      utc = -10;
    }
    localStorage.setItem('tzDrawer', `Etc/GMT${utc}`);
    localStorage.setItem('offsetValue', `1`);
  }, []);
  return (
    <TabComponent
      id='control-center-tab'
      ref={(ref: TabComponent) => (tabref = ref)}
      heightAdjustMode='Auto'
      statelessTemplates={['directiveTemplates']}
    >
      <TabItemsDirective>
        <TabItemDirective
          header={{ text: ' ' }}
          content={() => <CloudExecutionManagement />}
        />    
      </TabItemsDirective>
    </TabComponent>
  );
};
export default CloudExecution;
